
import api from '../../service/api';
import { useState, useEffect, useContext } from 'react';
import { useParams } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ProgressBar from '../progress/progressBar';
import { Alert, AlertTitle, Stack } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import CONSTANT from '../../Constant/Constant';
import {
    IconButton, List, ListItem, Divider, Typography, Tooltip
} from '@mui/material';
import SingleValue from '../detail-page/base/single-value';
import { DirectionContext } from '../../context/DirectionProvider';
import './TrackVNDetail.css';

const TrackVNDetail = (props) => {

    const [progressFlag, setProgressFlag] = useState(false);
    const [errorFlag, setErrorFlag] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [requestDetail, setRequestDetail] = useState(undefined);
    const direction = useContext(DirectionContext);
    let { id } = useParams();

    /**
    * Back to home
    */
    const goToHome = () => {
        props.history.push('');
    }

    /**
    * Back page
    */
    const goBack = () => {
        props.history.goBack();
    }

    /**
    * get status color class
    * @param {*} state
    * @returns
    */
    const getStatusClass = (state) => {
        switch (state) {
            case CONSTANT.STATE[0]:
                return 'text-white rounded py-2 px-3 bg-primary float-end';
            case CONSTANT.STATE[1]:
                return 'text-white rounded py-2 px-3 bg-success float-end';
            case CONSTANT.STATE[2]:
                return 'text-white rounded py-2 px-3 bg-danger float-end';
            case CONSTANT.STATE[3]:
                return 'text-white rounded py-2 px-3 bg-warning float-end';
            case CONSTANT.STATE[4]:
                return 'text-white rounded py-2 px-3 bg-primary float-end';
            case CONSTANT.STATE[5]:
                return 'text-white rounded py-2 px-3 bg-success float-end';
            case CONSTANT.STATE[6]:
                return 'text-white rounded py-2 px-3 bg-danger float-end';
            case CONSTANT.STATE[7]:
                return 'text-white rounded py-2 px-3 bg-success float-end';
            case CONSTANT.STATE[8]:
                return 'text-white rounded py-2 px-3 bg-warning float-end';
            case 'AWAITING_REVIEW':
                return 'text-white rounded py-2 px-3 bg-primary float-end';
            default:
                return 'text-white rounded py-2 px-3 bg-primary float-end';
        }
    }

    const getSafelyFromEntity = (key) => {
        const val = requestDetail[key] ?? null
        if (val && Array.isArray(val) && val.length > 0 && val[0].value !== undefined && val[0].value !== null) {
            return val[0].value
        }
        return null
    }

    const getSafelyFromEntityAddress = (key) => {
        if (!requestDetail.Address || !Array.isArray(requestDetail.Address)) {
            return null
        }
        const val = requestDetail.Address[0][key] ?? null
        if (val && Array.isArray(val) && val.length > 0 && val[0].value !== undefined && val[0].value !== null) {
            return val[0].value
        }
        return null
    }

    const getAllSpecialties = () => {
        /*
        "NewSpecialities": {
        "OtherSpecialty": [
        {
        "value": [
        "Accident / Trauma Surgery, Sport Traumatology | ATSST | ATSST"
        ]
        }
        ],
        "PrimarySpecialty": [
        {
        "value": "Abdominal Surgery | AS | AS"
        }
        ]
        },
        */
        const obj = requestDetail.NewSpecialities
        const specialties = []
        if (obj && obj.PrimarySpecialty && Array.isArray(obj.PrimarySpecialty)) {
            specialties.push("Primary: " + obj.PrimarySpecialty[0].value)
        }

        if (obj && obj.OtherSpecialty && Array.isArray(obj.OtherSpecialty)) {

            specialties.push("Other: " + obj.OtherSpecialty[0].value[0])
        }

        return specialties.length ? specialties : []
    }

    const getAllIdentifiers = () => {
        const obj = requestDetail.NewIdentifiers

        if (!obj || !obj.length) {
            return []
        }
        const items = []
        for (var item of obj) {
            if (item && item.ID && item.ID[0].value && item.Type && item.Type[0].value && item.AddedNew) {
                items.push({
                    type: item.Type[0].value.split("|")[0].trim(),
                    value: item.ID[0].value
                })
                // items.push(`${item.Type[0].value}: ${item.ID[0].value}`)
            }
        }
        return items
    }
    useEffect(() => {
        setProgressFlag(true);
        api.getAllRequest(false, null, id).then((res) => {
            setRequestDetail(res.data);
            setErrorFlag(false)
            setProgressFlag(false);
        }).catch((error) => {
            setErrorFlag(true);
            let errorDetail = error;
            let msg = errorDetail.response ? errorDetail.response.data.errorCode : 'Internal Server Error!';
            setErrorMsg(msg ? msg : 'Internal Server Error!');
            setProgressFlag(false)
        })

    }, [id])
    return (

        <section className={"container w-80 body-height extra-margin-top-less"}>
            {
                progressFlag
                &&
                <div className="d-flex justify-content-center extra-margin-top">
                    <ProgressBar />
                </div>
            }

            {
                !progressFlag && !errorFlag
                &&
                <>
                    <div className='container'>
                        {
                            !progressFlag && requestDetail
                            &&
                            <>
                                {

                                    <div className='row mt-5 mb-5'>
                                        <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
                                            <Tooltip disableFocusListener title="Back" id="tooltip">
                                                <IconButton aria-label="delete"
                                                    className="text-danger float-start"
                                                    onClick={goBack} color="secondary">
                                                    <ArrowBackIcon sx={{ transform: direction === 'rtl' ? 'rotate(180deg)' : '' }} />
                                                </IconButton>
                                            </Tooltip>

                                            <IconButton aria-label="delete " onClick={goToHome} className=' float-end'
                                                color="secondary">
                                                <Tooltip disableFocusListener title="Return To Home" id="tooltip">
                                                    <HomeIcon className="text-danger "
                                                    />
                                                </Tooltip>
                                            </IconButton>
                                        </Stack>

                                        <Stack direction={'row'} alignItems={'center'} sx={{ marginTop: '15px' }} justifyContent={'space-between'}>
                                            <Typography variant='subtitle1' className='fw-bold' id="requested-change">Requested Changes</Typography>
                                            <span data-wg-notranslate className={getStatusClass(requestDetail.status)}>{requestDetail.status === 'AWAITING_REVIEW' ? 'AWAITING REVIEW' : requestDetail.status} </span>
                                        </Stack>
                                        <List component="div" className='row '>
                                            {
                                                <>
                                                    {requestDetail.HcpEntityId &&
                                                        <ListItem className='col-6'>
                                                            <SingleValue label={'HCP Entity Id'} value={[{ value: requestDetail.HcpEntityId }]} />
                                                        </ListItem>
                                                    }
                                                    {requestDetail.HcoEntityId &&
                                                        <ListItem className='col-6'>
                                                            <SingleValue label={'HCO Entity Id'} value={[{ value: requestDetail.HcoEntityId }]} />
                                                        </ListItem>
                                                    }
                                                    {requestDetail.entityid &&
                                                        <ListItem className='col-6'>
                                                            <SingleValue label={'Entity Id'} value={[{ value: requestDetail.entityid }]} />
                                                        </ListItem>
                                                    }

                                                    {requestDetail.VendorName &&
                                                        <ListItem className='col-6'>
                                                            <SingleValue label={'Managed By'} value={[{ value: requestDetail.VendorName }]} />
                                                        </ListItem>
                                                    }
                                                    {
                                                        requestDetail?.CreatedBy &&
                                                        <ListItem className='col-6'>
                                                            <SingleValue label={'Requestor Id'} value={[{ value: requestDetail.CreatedBy }]} />
                                                        </ListItem>
                                                    }
                                                    {
                                                        requestDetail?.RequestorName &&
                                                        <ListItem className='col-6'>
                                                            <SingleValue label={'Requestor Name'} value={[{ value: requestDetail.RequestorName.includes(" - Network") ? requestDetail.RequestorName.split(" - Network")[0].trim() : requestDetail.RequestorName }]} />
                                                        </ListItem>
                                                    }
                                                    {
                                                        (requestDetail?.UserEmail || requestDetail?.RequestorEmail) &&
                                                        <ListItem className='col-6'>
                                                            <SingleValue label={'Requestor Email'} value={[{ value: requestDetail.UserEmail || requestDetail.RequestorEmail }]} />
                                                        </ListItem>
                                                    }
                                                    {requestDetail.Id &&

                                                        <ListItem className='col-6'>
                                                            <SingleValue label={'Request Id'} value={[{ value: requestDetail.Id }]} />
                                                        </ListItem>
                                                    }
                                                    {requestDetail.HcoOneKeyEid &&

                                                        <ListItem className='col-6'>
                                                            <SingleValue label={'HCO OneKey Id'} value={[{ value: requestDetail.HcoOneKeyEid }]} />
                                                        </ListItem>
                                                    }
                                                    {requestDetail.HcpOneKeyEid &&

                                                        <ListItem className='col-6'>
                                                            <SingleValue label={'Master VID'} value={[{ value: requestDetail.HcpOneKeyEid }]} />
                                                        </ListItem>
                                                    }
                                                    {requestDetail.CreatedDate &&

                                                        <ListItem className='col-6'>
                                                            <SingleValue label={'Created Time'} value={[{ value: requestDetail.CreatedDate }]} />
                                                        </ListItem>
                                                    }

                                                    {requestDetail.UpdatedDate &&
                                                        <ListItem className='col-6'>
                                                            <SingleValue label={'Updated Time'} value={[{ value: (requestDetail.UpdatedDate) }]} />
                                                        </ListItem>
                                                    }

                                                    {requestDetail.ActionDate &&
                                                        <ListItem className='col-6'>
                                                            <SingleValue label={'Reviewer Action Time'} value={[{ value: (requestDetail.ActionDate) }]} />
                                                        </ListItem>
                                                    }

                                                    {requestDetail["validation.requestComment"] &&
                                                        <ListItem className='col-6'>
                                                            <SingleValue label={'Requester Comment'} value={[{ value: requestDetail["validation.requestComment"].split("||", 1) }]} />
                                                        </ListItem>
                                                    }

                                                    {((requestDetail.status.toLowerCase() === 'approved') || (requestDetail.status.toLowerCase() === 'rejected')) &&
                                                        <ListItem className='col-6'>
                                                            <SingleValue label={'Reviewer Comment'} value={[{ value: requestDetail.ActionComment }]} />
                                                        </ListItem>
                                                    }


                                                    <ListItem className='col-6'>
                                                        <Typography variant='subtitle1' className='fw-bold' id="request-header">Attribute Changes:</Typography>

                                                    </ListItem>
                                                    <Divider />
                                                </>
                                            }
                                            <div className='border py-3 container px-4'>

                                                <div className='hr-at-end'>
                                                    {getSafelyFromEntity('Prefix') !== null &&
                                                        <div>
                                                            <b>Prefix: </b>{getSafelyFromEntity('Prefix')}
                                                        </div>}
                                                    {getSafelyFromEntity('FirstName') !== null &&
                                                        <div>
                                                            <b>First Name: </b>{getSafelyFromEntity('FirstName')}
                                                        </div>}
                                                    {getSafelyFromEntity('MiddleName') !== null &&
                                                        <div>
                                                            <b>Middle Name: </b>{getSafelyFromEntity('MiddleName')}
                                                        </div>}
                                                    {getSafelyFromEntity('LastName') !== null &&
                                                        <div>
                                                            <b>Last Name: </b>{getSafelyFromEntity('LastName')}
                                                        </div>}
                                                    {getSafelyFromEntity('ClassificationCode') !== null &&
                                                        <div>
                                                            <b>Classification Code: </b>{getSafelyFromEntity('ClassificationCode')}
                                                        </div>}
                                                    {getSafelyFromEntity('Gender') !== null &&
                                                        <div>
                                                            <b>Gender: </b>{getSafelyFromEntity('Gender')}
                                                        </div>}
                                                </div>

                                                <div className='hr-at-end'>
                                                    {getSafelyFromEntity('Email') !== null &&
                                                        <div>
                                                            <b>Email: </b>{getSafelyFromEntity('Email')}
                                                        </div>}
                                                    {getSafelyFromEntity('Phone') !== null &&
                                                        <div>
                                                            <b>Phone: </b>{getSafelyFromEntity('Phone')}
                                                        </div>}
                                                </div>

                        <div className='hr-at-end'>
                          {getSafelyFromEntityAddress('AddressLine1') !== null &&
                            <div>
                              <b>AddressLine1: </b>{getSafelyFromEntityAddress('AddressLine1')}
                            </div>}
                          {getSafelyFromEntityAddress('City') !== null &&
                            <div>
                              <b>City: </b>{getSafelyFromEntityAddress('City')}
                            </div>}
                          {getSafelyFromEntityAddress('StateProvince') !== null &&
                            <div>
                              <b>State/Province: </b>{getSafelyFromEntityAddress('StateProvince')}
                            </div>}
                          {getSafelyFromEntityAddress('Zip') !== null &&
                            <div>
                              <b>Zip: </b>{getSafelyFromEntityAddress('Zip')}
                            </div>}
                        </div>

                                                {getAllSpecialties().length > 0 && <div className='hr-at-end'>
                                                    <b>Specialties:</b><br />
                                                    {getAllSpecialties().map((item, index) => <div key={index}>{item}</div>)}
                                                </div>}

                                                {getAllIdentifiers().length > 0 && <div>
                                                    <b>Identifiers:</b><br />
                                                    {getAllIdentifiers().map((item, index) => <div key={index}>{item.type}: {item.value}</div>)}
                                                </div>}

                                                {/* <pre>{JSON.stringify(requestDetail, null, 4)}</pre> */}
                                            </div>
                                        </List>
                                    </div>
                                }
                            </>
                        }
                    </div>
                </>
            }
            {
                errorFlag
                &&
                <div className="d-flex justify-content-center extra-margin-top">
                    <Alert severity="error" className='container'>
                        <AlertTitle id="alert-text">{errorMsg} !</AlertTitle>
                    </Alert>
                </div>
            }

        </section>
    )
}

export default TrackVNDetail;


